import React from "react";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

export default function AddGroupHeader({
  setCreateNewGroupSection,
  fetchAllUser,
}) {
  return (
    <div className="w-full items-center min-h-[67px] py-2.5 bg-white text-black flex gap-4 px-5 border-b border-[#EBEBEB]">
      <MdOutlineArrowBackIosNew
        className="border border-gray-300 p-1.5 rounded text-3xl cursor-pointer"
        onClick={() => {
          setCreateNewGroupSection(0); // Go back from 'Add Group' to 'New Chat'
          fetchAllUser(1, "");
        }}
      />
      <h1 className="text-lg font-semibold text-center">Add Group Members</h1>
    </div>
  );
}
